/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import ComponentBase from '../Utility/ComponentBase';
import Communicator from './Communicator';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Debug feature for displaying [[Communicator]] data on screen. */
@cc._decorator.ccclass
export default abstract class CommunicatorDisplay extends ComponentBase
{
    // #region Display Properties

    /** @hidden */
    @property({ type: cc.Label, visible: true })
    private _nodeNameLabel: cc.Label = null;

    /** @hidden */
    @property({ type: cc.Label, visible: true })
    private _lastRequest: cc.Label = null;

    /** @hidden */
    @property({ type: cc.Label, visible: true })
    private _lastResponse: cc.Label = null;

    /** @hidden */
    @property({ type: cc.Label, visible: true })
    private _lastReadyStateChange: cc.Label = null;

    /** @hidden */
    @property({ type: cc.Label, visible: true })
    private _lastError: cc.Label = null;

    // #endregion

    /** @hidden */
    protected communicatorRef: InjectableComponent<Communicator> = new InjectableComponent<Communicator>();

    /** @hidden */
    protected setContexts(): void
    {
        this.communicatorRef.SetContext(Communicator);
    }

    /** @hidden */
    protected start(): void
    {
        this.communicatorRef.SetContext(Communicator);

        if (!this.communicatorRef.Value)
        {
            cc.error(`No Communicator configured for CommunicatorDisplay node [${""}]`);
            this.enabled = false;
            return;
        }

        this._nodeNameLabel.string = this.node.name;
    }

    /** @hidden */
    protected update(dt: number): void
    {
        if (this._lastRequest)
        {
            this._lastRequest.string = this.communicatorRef.Value.LastRequest;
        }

        if (this._lastResponse)
        {
            this._lastResponse.string = this.communicatorRef.Value.LastResponse;
        }

        if (this._lastReadyStateChange)
        {
            this._lastReadyStateChange.string = this.communicatorRef.Value.LastReadyStateChange;
        }

        if (this._lastError)
        {
            this._lastError.string = this.communicatorRef.Value.LastError;
        }
    }
}
